module.exports = {
    "breadcrumbs": `\u{5BFC}\u{822A}\u{680F}`
};


//# sourceMappingURL=zh-CN.main.js.map
